<script lang="ts">
    import WbgtLevel from "../../../public/icons/wbgt_level.svelte";
    import { conditions, cType, Observation, Widget, widgetInfo, WidgetType } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color"
    let errorFill = "--error-color"
    let threshold = undefined;
    let conditionValue;
    let displayValue;

    widgetInfo.subscribe((value: Widget) => {
        if (value) {
            if(value.type != WidgetType.DEF && isPrimaryCondition){
                fill = "--primary-color"
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
            } else {
                const currentConditions = value.widgetConditions;
                const temperatureCondition = currentConditions.find(
                    condition => condition.conditionType === cType.WBGT
                );
                if (temperatureCondition) {
                    threshold = temperatureCondition.threshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        if(value && value.wgbt){
            const wbgtValue = value.wgbt.value;
            conditionValue = wbgtValue;
            displayValue = displayNumberWithDecimal(wbgtValue);
            if(threshold != undefined && wbgtValue >= threshold)
                fill = errorFill;
        }
        else{
            conditionValue = "--";
            displayValue = "--";
        }
    });

    function displayNumberWithDecimal(value: number){
        var numAsString = value.toString();
        var decimalPlaces = 1;
        if(numAsString.includes(".")){
            var split = numAsString.split(".");
            if(split.length > 1 && split[1].length > 0)
                decimalPlaces = numAsString.split(".")[1].length;
        }
        return value.toFixed(decimalPlaces);
    }

</script>

<div class="cc-container" style="color: var({fill});">
    {#if !isPrimaryCondition}
      <div class="weatherIcon">
        <WbgtLevel fill="var({fill})" wbgtValue={conditionValue} />
      </div>
    {/if}

    <div class="{isPrimaryCondition ? "primary-value":"value"}">{displayValue}&deg;</div>
    
    <div class="cc-label">
        <div class="{isPrimaryCondition ? "primary-label" : "label"}">WBGT</div>
    </div> 
    

</div>
